/**
 * Purpose:
 *   Renders button icon with proper sizing and positioning.
 */

import React from 'react';
import { cx } from '@/util/functions/cx';
import { buttonStyles } from './Button.styles';

export interface IButtonIconProps {
  size: number;
  position: 'leading' | 'trailing';
  iconOnly?: boolean;
  children: React.ReactNode;
}

export function ButtonIcon({
  size,
  position,
  iconOnly = false,
  children,
}: IButtonIconProps) {
  return (
    <span
      className={cx(
        buttonStyles.icon,
        !iconOnly && position === 'leading'
          ? buttonStyles.iconLeading
          : '',
        !iconOnly && position === 'trailing'
          ? buttonStyles.iconTrailing
          : ''
      )}
      style={{ width: size, height: size }}
    >
      {children}
    </span>
  );
}
